<app-rb-grid
  [gridConfig]="gridConfig"
  [getSetup]="getGridSetup"
  [getData]="getGridData"
>
  <button
    mat-raised-button
    color="primary"
    class="header-button"
    matTooltip="Limit 100,000"
    matTooltipPosition="above"
    [disabled]="fileLoading"
    (click)="downloadPolicyList()"
  >
    <span class="button-label-with-icon">
      @if (fileLoading) {
        <mat-spinner diameter="20" />
      } @else {
        <mat-icon>cloud_download</mat-icon>
      }
      Download Policy List
    </span>
  </button>
</app-rb-grid>
